import $ from 'jquery';

export default class TabBar {

  constructor($el) {
    this.tabBarBtn = $el.find('.js-tab-bar_btn');
    this.tabPaneCloseBtn = $('.js-tab-bar-pane_close'); 
    this.tabPanes = $('.js-tab-bar-pane');
    this.lastOpenPane = null;

    this.handleEvents();
  }

  handleEvents() {
    this.tabBarBtn.click(e => {
      let targetPane = this.getPane(e.currentTarget);

      if (this.lastOpenPane &&
          this.lastOpenPane[0] === targetPane[0]) return;

      if (this.lastOpenPane &&
          this.lastOpenPane[0] !== targetPane[0]) {
        this.unsetActiveTab();
        this.setActiveTab(e.currentTarget);
        this.hidePane();
        setTimeout(() => {
          this.showPane(targetPane);
          this.lastOpenPane = targetPane;
        }, 300);
      }

      if (!this.lastOpenPane) {
        this.setActiveTab(e.currentTarget);
        this.showPane(targetPane);
        this.lastOpenPane = targetPane;      
      }
    });

    this.tabPaneCloseBtn.click(e => {
      this.hidePane();
      this.unsetActiveTab();
      this.lastOpenPane = null;
    });
  }

  showPane(targetPane) {
    targetPane.addClass('is-open');
  }

  hidePane() {
    return this.lastOpenPane &&
      this.lastOpenPane.removeClass('is-open');
  }

  setActiveTab(tabActive) {
    $(tabActive).addClass('is-active');
  }

  unsetActiveTab() {
    this.tabBarBtn.filter('.is-active')
      .removeClass('is-active');
  }

  getPane(tabActive) {
    return this.tabPanes.filter(
      this.getPaneIdFrom(tabActive)
    );
  }

  getPaneIdFrom(tabActive) {
    return '#' + tabActive.getAttribute('aria-controls');
  }
}


// WEBPACK FOOTER //
// ./src/components/tab-bar/tabBar.js